import { render, staticRenderFns } from "./administradores_parque.vue?vue&type=template&id=fb0f702c&scoped=true"
import script from "./administradores_parque.vue?vue&type=script&lang=js"
export * from "./administradores_parque.vue?vue&type=script&lang=js"
import style0 from "./administradores_parque.vue?vue&type=style&index=0&id=fb0f702c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0f702c",
  null
  
)

export default component.exports